import type { ReactElement } from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '@ardoq/design-tokens';

const shimmerSweep = keyframes`
  0% {
    -webkit-mask-position: 150% 0%;
    mask-position: 150% 0%;
  }
  100% {
    -webkit-mask-position: -50% 0%;
    mask-position: -50% 0%;
  }
`;

export const ShimmerLabel = ({ label }: { label: string }): ReactElement => (
  <Label>
    {label}
    <ShimmerText aria-hidden="true">{label}</ShimmerText>
  </Label>
);

const Label = styled.span`
  position: relative;
  display: inline-block;
`;

const ShimmerText = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  color: ${colors.white950};
  mask-image: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0) 43%,
    rgba(0, 0, 0, 0.4) 48%,
    rgba(0, 0, 0, 1) 50%,
    rgba(0, 0, 0, 0.35) 53%,
    rgba(0, 0, 0, 0) 58%,
    rgba(0, 0, 0, 0) 100%
  );
  mask-size: 200% 100%;
  mask-repeat: no-repeat;
  mask-position: 150% 0%;
  animation: ${shimmerSweep} 3.5s linear infinite;
  pointer-events: none;

  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`;
